<!-- 油卡管理 -->
<template>
  <v-container fluid>
    <!-- 查询条件：平台名称、卡号、状态 -->
    <v-row class="query-row">
      <v-col cols="12" xl="2" lg="2" md="4" sm="6">
        <v-text-field v-model="queryForm.platform_name" label="平台名称" dense outlined clearable hide-details
          @keyup.enter="search()"></v-text-field>
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="4" sm="6">
        <v-text-field v-model="queryForm.card_no" label="卡号" dense outlined clearable hide-details
          @keyup.enter="search()"></v-text-field>
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="4" sm="6">
        <v-select v-model="queryForm.status" :items="statusOptions" item-text="label" item-value="value"
          label="状态" no-data-text="无" dense outlined clearable hide-details
          :menu-props="{ bottom: true, offsetY: true }">
        </v-select>
      </v-col>
      <v-col cols="12" xl="3" lg="3" md="6" sm="6">
        <a-space>
          <v-btn @click="search()" color="primary" dark tile>
            <v-icon small>mdi-magnify</v-icon>查询
          </v-btn>
          <v-btn @click="openCreate" color="success" dark tile>
            <v-icon small>mdi-plus</v-icon>新增油卡
          </v-btn>
        </a-space>
      </v-col>
    </v-row>

    <v-card tile>
      <v-card-title class="d-flex align-center py-2 px-3" style="background-color: #fff;">
        <span class="text-subtitle-2">共 {{ count }} 条数据</span>
        <v-spacer></v-spacer>
        <v-menu bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn small outlined v-bind="attrs" v-on="on" class="grey lighten-3">{{ limit }}/页</v-btn>
          </template>
          <v-list>
            <v-list-item v-for="item in pages" :key="item.value" @click="changeLimit(item.value)">
              <v-list-item-title>{{ item.value }}/页</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-card-title>
      <a-table size="small" :columns="headers" :data-source="pageList" row-key="_id" :pagination="false" bordered
        :locale="{ emptyText: '暂无数据' }" :scroll="{ x: width }">
        <!-- 序号：按分页连续编号 -->
        <template slot="index" slot-scope="text, record, index">
          {{ (page - 1) * limit + index + 1 }}
        </template>
        <!-- 充值金额：可点击查看该卡充值列表 -->
        <template slot="recharge_amount" slot-scope="text, record">
          <a class="primary--text font-weight-bold" @click="openRecharge(record)">
            {{ formatMoney(text) }}
          </a>
        </template>
        <!-- 余额 -->
        <template slot="balance" slot-scope="text">
          <span class="font-weight-bold">{{ formatMoney(text) }}</span>
        </template>
        <!-- 备注超长省略 -->
        <template slot="remark" slot-scope="text">
          <a-tooltip v-if="text" :title="text" placement="topLeft">
            <span>{{ text }}</span>
          </a-tooltip>
        </template>
        <!-- 状态：1 启用 / 0 禁用 -->
        <template slot="status" slot-scope="text">
          <a-tag :color="text === 1 ? 'green' : 'red'">{{ text === 1 ? "启用" : "禁用" }}</a-tag>
        </template>
        <!-- 操作：充值 / 编辑 / 删除（nowrap 防止挤压换行） -->
        <template slot="action" slot-scope="text, record">
          <a-space :size="4" style="white-space: nowrap;">
            <a @click="openRecharge(record)">充值记录</a>
            <a-divider type="vertical" />
            <a @click="openEdit(record)">编辑</a>
            <a-divider type="vertical" />
            <a-popconfirm :title="`确认删除油卡「${record.card_no}」?`" ok-text="确定" cancel-text="取消" placement="left"
              @confirm="removeItem(record)">
              <a class="error--text">删除</a>
            </a-popconfirm>
          </a-space>
        </template>
      </a-table>
    </v-card>

    <v-card tile class="mt-2">
      <v-pagination v-if="length > 1" v-model="page" :page="page" :length="length" total-visible="10"></v-pagination>
    </v-card>

    <!-- 新增 / 编辑油卡弹窗 -->
    <v-dialog v-model="dialogVisible" max-width="720" persistent scrollable>
      <v-card>
        <v-card-title class="primary white--text">
          {{ dialogMode === "create" ? "新增油卡" : "编辑油卡" }}
        </v-card-title>
        <v-card-text class="pt-4">
          <v-form ref="form" v-model="formValid" :lazy-validation="true">
            <v-row>
              <v-col cols="12" md="6" sm="6">
                <v-text-field v-model="form.platform_name" label="平台名称" dense outlined required
                  :rules="[v => !!v || '请填写平台名称']"></v-text-field>
              </v-col>
              <v-col cols="12" md="6" sm="6">
                <v-text-field v-model="form.card_no" label="卡号" dense outlined required
                  :rules="[v => !!v || '请填写卡号']"></v-text-field>
              </v-col>
              <v-col cols="12" md="6" sm="6">
                <v-menu ref="open_date_menu" v-model="open_date_menu" :close-on-content-click="false"
                  :return-value.sync="form.open_date" transition="scale-transition" min-width="auto" offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="form.open_date" label="开卡日期" append-icon="mdi-calendar" readonly
                      v-bind="attrs" v-on="on" dense outlined clearable required hide-details
                      :rules="[v => !!v || '请选择开卡日期']"></v-text-field>
                  </template>
                  <v-date-picker v-model="form.open_date" no-title scrollable locale="zh-cn"
                    @input="() => { $refs.open_date_menu.save(form.open_date); open_date_menu = false; }"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="6" sm="6">
                <!-- 状态：1 启用 / 0 禁用 -->
                <v-radio-group v-model="form.status" row class="mt-0 pt-2">
                  <v-radio color="primary" label="启用" :value="1"></v-radio>
                  <v-radio color="error" label="禁用" :value="0"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12">
                <v-textarea v-model="form.remark" label="备注" dense outlined rows="2"></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text tile @click="dialogVisible = false">取消</v-btn>
          <v-btn color="primary" dark tile @click="submitForm">保存</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 充值列表弹窗：查看充值记录、添加充值信息 -->
    <v-dialog v-model="rechargeVisible" max-width="760" persistent scrollable>
      <v-card>
        <v-card-title class="primary white--text d-flex align-center">
          充值记录（{{ currentCard.platform_name }} - {{ currentCard.card_no }}）
          <v-spacer></v-spacer>
          <v-btn small color="success" dark tile @click="openAddRecharge">
            <v-icon small left>mdi-plus</v-icon>添加充值
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-3">
          <!-- 该卡充值汇总 -->
          <v-row class="mb-2">
            <v-col cols="6">
              <span class="grey--text">累计充值：</span>
              <span class="primary--text font-weight-bold">{{ formatMoney(currentCard.recharge_amount) }} 元</span>
            </v-col>
            <v-col cols="6">
              <span class="grey--text">当前余额：</span>
              <span class="font-weight-bold">{{ formatMoney(currentCard.balance) }} 元</span>
            </v-col>
          </v-row>
          <a-table size="small" :columns="rechargeHeaders" :data-source="currentRechargeList" row-key="_id"
            :pagination="false" bordered :locale="{ emptyText: '暂无充值记录' }">
            <!-- 充值记录序号 -->
            <template slot="r_index" slot-scope="text, record, index">
              {{ index + 1 }}
            </template>
            <template slot="r_amount" slot-scope="text">
              <span class="font-weight-bold">{{ formatMoney(text) }}</span>
            </template>
            <template slot="r_remark" slot-scope="text">
              <a-tooltip v-if="text" :title="text" placement="topLeft">
                <span>{{ text }}</span>
              </a-tooltip>
            </template>
            <template slot="r_action" slot-scope="text, record">
              <a-popconfirm title="确认删除该条充值记录? 删除后余额将相应扣减。" ok-text="确定" cancel-text="取消"
                placement="left" @confirm="removeRecharge(record)">
                <a class="error--text">删除</a>
              </a-popconfirm>
            </template>
          </a-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text tile @click="rechargeVisible = false">关闭</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 添加充值信息弹窗 -->
    <v-dialog v-model="rechargeFormVisible" max-width="480" persistent>
      <v-card>
        <v-card-title class="primary white--text">添加充值</v-card-title>
        <v-card-text class="pt-4">
          <v-form ref="rechargeForm" v-model="rechargeFormValid" :lazy-validation="true">
            <v-menu ref="r_date_menu" v-model="r_date_menu" :close-on-content-click="false"
              :return-value.sync="rechargeForm.recharge_date" transition="scale-transition" min-width="auto" offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="rechargeForm.recharge_date" label="充值日期" append-icon="mdi-calendar" readonly
                  v-bind="attrs" v-on="on" dense outlined clearable required hide-details
                  :rules="[v => !!v || '请选择充值日期']"></v-text-field>
              </template>
              <v-date-picker v-model="rechargeForm.recharge_date" no-title scrollable locale="zh-cn"
                @input="() => { $refs.r_date_menu.save(rechargeForm.recharge_date); r_date_menu = false; }"></v-date-picker>
            </v-menu>
            <v-text-field v-model.number="rechargeForm.amount" label="充值金额(元)" type="number" dense outlined required
              :rules="[v => (v !== '' && v != null && Number(v) > 0) || '请输入大于0的充值金额']"></v-text-field>
            <v-textarea v-model="rechargeForm.remark" label="备注" dense outlined rows="2"></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text tile @click="rechargeFormVisible = false">取消</v-btn>
          <v-btn color="primary" dark tile @click="submitRecharge">保存</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import _ from "underscore";

export default {
  name: "OilCard",
  data() {
    return {
      // mock 开关：true=本地模拟数据；后端接口出来后改为 false，并打开 getdata/save/remove/recharge 里的真实请求
      useMock: true,
      // 查询条件：平台名称、卡号、状态
      queryForm: {
        platform_name: "",
        card_no: "",
        status: null,
      },
      // 状态选项：1 启用 / 0 禁用
      statusOptions: [
        { label: "启用", value: 1 },
        { label: "禁用", value: 0 },
      ],
      pages: [
        { text: "20/页", value: 20 },
        { text: "50/页", value: 50 },
        { text: "100/页", value: 100 },
      ],
      headers: [
        { title: "序号", dataIndex: "index", scopedSlots: { customRender: "index" }, width: 70, align: "center" },
        { title: "平台名称", dataIndex: "platform_name", width: 200, align: "left" },
        { title: "卡号", dataIndex: "card_no", width: 200, align: "center" },
        { title: "充值金额(元)", dataIndex: "recharge_amount", scopedSlots: { customRender: "recharge_amount" }, width: 130, align: "center" },
        { title: "余额(元)", dataIndex: "balance", scopedSlots: { customRender: "balance" }, width: 120, align: "center" },
        { title: "开卡日期", dataIndex: "open_date", width: 120, align: "center" },
        { title: "状态", dataIndex: "status", scopedSlots: { customRender: "status" }, width: 90, align: "center" },
        { title: "备注", dataIndex: "remark", scopedSlots: { customRender: "remark" }, width: 180, align: "left", ellipsis: true },
        { title: "操作", dataIndex: "action", scopedSlots: { customRender: "action" }, width: 200, align: "center" },
      ],
      // 充值记录表头
      rechargeHeaders: [
        { title: "序号", dataIndex: "r_index", scopedSlots: { customRender: "r_index" }, width: 70, align: "center" },
        { title: "充值日期", dataIndex: "recharge_date", width: 140, align: "center" },
        { title: "充值金额(元)", dataIndex: "amount", scopedSlots: { customRender: "r_amount" }, width: 130, align: "center" },
        { title: "备注", dataIndex: "remark", scopedSlots: { customRender: "r_remark" }, align: "left", ellipsis: true },
        { title: "操作", dataIndex: "r_action", scopedSlots: { customRender: "r_action" }, width: 90, align: "center" },
      ],
      // 全量 mock 数据
      allList: [],
      // 查询过滤后的数据
      list: [],
      page: 1,
      limit: 20,
      count: 0,
      length: 0,
      // 油卡新增/编辑弹窗
      dialogVisible: false,
      dialogMode: "create", // create / edit
      formValid: false,
      form: this.emptyForm(),
      open_date_menu: false,
      // 充值列表弹窗
      rechargeVisible: false,
      currentCardId: "",
      // 添加充值弹窗
      rechargeFormVisible: false,
      rechargeFormValid: false,
      r_date_menu: false,
      rechargeForm: {
        recharge_date: "",
        amount: "",
        remark: "",
      },
    };
  },
  computed: {
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 120), 0);
    },
    // 当前页数据（前端分页）
    pageList() {
      const start = (this.page - 1) * this.limit;
      return this.list.slice(start, start + this.limit);
    },
    // 当前查看充值记录的油卡
    currentCard() {
      return this.allList.find((it) => it._id === this.currentCardId) || {};
    },
    // 当前油卡的充值记录（按日期倒序）
    currentRechargeList() {
      const list = this.currentCard.recharge_list || [];
      return [...list].sort((a, b) => (a.recharge_date < b.recharge_date ? 1 : -1));
    },
  },
  mounted() {
    this.getdata();
  },
  methods: {
    emptyForm() {
      return {
        _id: "",
        platform_name: "",
        card_no: "",
        open_date: "",
        status: 1, // 默认启用
        remark: "",
      };
    },
    formatMoney(v) {
      return v == null || v === "" ? "0.00" : Number(v).toFixed(2);
    },
    // 汇总充值金额
    sumRecharge(list) {
      return Math.round(list.reduce((acc, it) => acc + (Number(it.amount) || 0), 0) * 100) / 100;
    },
    search() {
      this.page = 1;
      this.getdata();
    },
    getdata() {
      if (this.useMock) {
        this.getMockData();
        return;
      }
      // TODO 接口联调：POST /oilcard/list
      // 参数：platform_name 平台名称(模糊)；card_no 卡号(模糊)；status 状态 1启用/0禁用
      // this.$toast.loading({ message: "" });
      // this.$api.doAPI("/oilcard/list", { page: this.page, limit: this.limit, ...this.queryForm }).then((res) => {
      //   this.$toast.clear();
      //   if (res.code === 0) {
      //     this.list = res.data.list;
      //     this.count = res.data.count;
      //     this.length = res.data.length || Math.max(1, Math.ceil(this.count / this.limit));
      //   } else {
      //     this.$alert(res.msg);
      //   }
      // }).catch((err) => { this.$toast.clear(); console.error(err); });
    },
    // 模拟接口数据
    getMockData() {
      if (!this.allList.length) {
        const raw = [
          {
            platform_name: "中国石化加油卡", card_no: "1000114320987654321", open_date: "2025-03-12", status: 1, remark: "公司主卡，豫A37230D使用",
            recharge_list: [
              { recharge_date: "2026-09-01", amount: 5000, remark: "月度统一充值" },
              { recharge_date: "2026-08-01", amount: 5000, remark: "" },
              { recharge_date: "2026-07-02", amount: 3000, remark: "长途任务追加" },
            ],
            consume_total: 11200, // 累计消费（mock，用于计算余额）
          },
          {
            platform_name: "中国石油加油卡", card_no: "9020012345678901234", open_date: "2025-05-20", status: 1, remark: "备用车油卡",
            recharge_list: [
              { recharge_date: "2026-09-05", amount: 3000, remark: "" },
              { recharge_date: "2026-08-10", amount: 3000, remark: "" },
            ],
            consume_total: 4200,
          },
          {
            platform_name: "中国石化加油卡", card_no: "1000114320981234567", open_date: "2025-06-08", status: 1, remark: "豫A37301D专用",
            recharge_list: [
              { recharge_date: "2026-09-10", amount: 4000, remark: "" },
              { recharge_date: "2026-08-15", amount: 4000, remark: "季度充值" },
              { recharge_date: "2026-07-18", amount: 2000, remark: "" },
            ],
            consume_total: 7600,
          },
          {
            platform_name: "壳牌加油卡", card_no: "7000888866665555", open_date: "2024-11-30", status: 0, remark: "已停用，合作到期",
            recharge_list: [
              { recharge_date: "2025-12-01", amount: 2000, remark: "" },
            ],
            consume_total: 2000,
          },
        ];
        this.allList = raw.map((it, i) => {
          // 初始充值记录补充 _id，避免删除时误匹配
          const recharge_list = (it.recharge_list || []).map((r, j) => ({
            _id: "rc_" + (i + 1) + "_" + (j + 1),
            ...r,
          }));
          const recharge_amount = this.sumRecharge(recharge_list);
          return {
            _id: "oc_" + (i + 1),
            platform_name: it.platform_name,
            card_no: it.card_no,
            open_date: it.open_date,
            status: it.status,
            remark: it.remark,
            recharge_list,
            // mock 余额 = 累计充值 - 累计消费；真实环境以接口返回的 balance 为准
            recharge_amount,
            balance: Math.round((recharge_amount - (it.consume_total || 0)) * 100) / 100,
          };
        });
      }
      // 条件过滤：平台名称 + 卡号 + 状态
      let result = [...this.allList];
      if (this.queryForm.platform_name) {
        const kw = this.queryForm.platform_name.trim();
        result = result.filter((it) => (it.platform_name || "").includes(kw));
      }
      if (this.queryForm.card_no) {
        const kw = this.queryForm.card_no.trim();
        result = result.filter((it) => (it.card_no || "").includes(kw));
      }
      if (this.queryForm.status !== null && this.queryForm.status !== undefined && this.queryForm.status !== "") {
        result = result.filter((it) => it.status === this.queryForm.status);
      }
      this.list = result;
      this.count = result.length;
      this.length = Math.max(1, Math.ceil(this.count / this.limit));
      if (this.page > this.length) this.page = 1;
    },
    changeLimit(v) {
      this.limit = v;
      this.page = 1;
      this.getdata();
    },
    openCreate() {
      this.form = this.emptyForm();
      this.dialogMode = "create";
      this.dialogVisible = true;
      this.$nextTick(() => this.$refs.form && this.$refs.form.resetValidation());
    },
    openEdit(record) {
      this.form = {
        _id: record._id,
        platform_name: record.platform_name || "",
        card_no: record.card_no || "",
        open_date: record.open_date || "",
        status: record.status,
        remark: record.remark || "",
      };
      this.dialogMode = "edit";
      this.dialogVisible = true;
      this.$nextTick(() => this.$refs.form && this.$refs.form.resetValidation());
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        if (this.useMock) {
          this.saveMock();
          return;
        }
        // TODO 接口联调：POST /oilcard/save（新增/编辑，编辑传 _id）
        // this.$toast.loading({ message: "" });
        // this.$api.doAPI("/oilcard/save", { ...this.form }).then((res) => {
        //   this.$toast.clear();
        //   if (res.code === 0) {
        //     this.$message.success(this.dialogMode === "create" ? "新增成功" : "已更新");
        //     this.dialogVisible = false;
        //     this.getdata();
        //   } else {
        //     this.$alert(res.msg);
        //   }
        // }).catch((err) => { this.$toast.clear(); console.error(err); });
      });
    },
    saveMock() {
      const data = { ...this.form };
      if (this.dialogMode === "create") {
        this.allList = [
          {
            ...data,
            _id: "oc_" + Date.now(),
            recharge_list: [],
            recharge_amount: 0,
            balance: 0,
          },
          ...this.allList,
        ];
        this.$message.success("新增成功");
      } else {
        this.allList = this.allList.map((it) => (it._id === data._id ? { ...it, ...data } : it));
        this.$message.success("已更新");
      }
      this.dialogVisible = false;
      this.getdata();
    },
    removeItem(record) {
      if (this.useMock) {
        this.allList = this.allList.filter((it) => it._id !== record._id);
        this.$message.success("已删除");
        this.getdata();
        return;
      }
      // TODO 接口联调：POST /oilcard/remove
      // 参数：_id 油卡ID
      // this.$toast.loading({ message: "" });
      // this.$api.doAPI("/oilcard/remove", { _id: record._id }).then((res) => {
      //   this.$toast.clear();
      //   if (res.code === 0) {
      //     this.$message.success("已删除");
      //     this.getdata();
      //   } else {
      //     this.$alert(res.msg);
      //   }
      // }).catch((err) => { this.$toast.clear(); console.error(err); });
    },
    // 打开充值列表
    openRecharge(record) {
      this.currentCardId = record._id;
      this.rechargeVisible = true;
    },
    openAddRecharge() {
      this.rechargeForm = {
        recharge_date: this.$moment().format("YYYY-MM-DD"),
        amount: "",
        remark: "",
      };
      this.rechargeFormVisible = true;
      this.$nextTick(() => this.$refs.rechargeForm && this.$refs.rechargeForm.resetValidation());
    },
    submitRecharge() {
      this.$refs.rechargeForm.validate((valid) => {
        if (!valid) return;
        if (this.useMock) {
          this.saveRechargeMock();
          return;
        }
        // TODO 接口联调：POST /oilcard/recharge/add
        // 参数：card_id 油卡ID；recharge_date 充值日期(YYYY-MM-DD)；amount 金额；remark 备注
        // 充值成功后累计充值金额、余额以后端返回为准并刷新列表
        // this.$toast.loading({ message: "" });
        // this.$api.doAPI("/oilcard/recharge/add", {
        //   card_id: this.currentCardId,
        //   ...this.rechargeForm,
        // }).then((res) => {
        //   this.$toast.clear();
        //   if (res.code === 0) {
        //     this.$message.success("充值成功");
        //     this.rechargeFormVisible = false;
        //     this.getdata();
        //   } else {
        //     this.$alert(res.msg);
        //   }
        // }).catch((err) => { this.$toast.clear(); console.error(err); });
      });
    },
    saveRechargeMock() {
      const amount = Number(this.rechargeForm.amount) || 0;
      this.allList = this.allList.map((it) => {
        if (it._id !== this.currentCardId) return it;
        const recharge_list = [
          ...(it.recharge_list || []),
          { _id: "rc_" + Date.now(), ...this.rechargeForm, amount },
        ];
        return {
          ...it,
          recharge_list,
          recharge_amount: this.sumRecharge(recharge_list),
          // mock：充值后余额等额增加（真实环境余额以后端返回为准）
          balance: Math.round((Number(it.balance || 0) + amount) * 100) / 100,
        };
      });
      this.$message.success("充值成功");
      this.rechargeFormVisible = false;
    },
    removeRecharge(record) {
      if (this.useMock) {
        this.allList = this.allList.map((it) => {
          if (it._id !== this.currentCardId) return it;
          const recharge_list = (it.recharge_list || []).filter((r) => r._id !== record._id);
          return {
            ...it,
            recharge_list,
            recharge_amount: this.sumRecharge(recharge_list),
            // 删除充值记录后余额等额扣减
            balance: Math.round((Number(it.balance || 0) - (Number(record.amount) || 0)) * 100) / 100,
          };
        });
        this.$message.success("已删除");
        return;
      }
      // TODO 接口联调：POST /oilcard/recharge/remove
      // 参数：card_id 油卡ID；_id 充值记录ID
      // this.$toast.loading({ message: "" });
      // this.$api.doAPI("/oilcard/recharge/remove", { card_id: this.currentCardId, _id: record._id }).then((res) => {
      //   this.$toast.clear();
      //   if (res.code === 0) {
      //     this.$message.success("已删除");
      //     this.getdata();
      //   } else {
      //     this.$alert(res.msg);
      //   }
      // }).catch((err) => { this.$toast.clear(); console.error(err); });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .row {
  margin-bottom: 0 !important;
}

/* 查询条件行与下方表格保持间距 */
/deep/ .row.query-row {
  margin-bottom: 16px !important;
}

/deep/ .col,
.col-12 {
  padding-bottom: 0 !important;
}

/deep/ .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

p {
  margin: 0;
}
</style>
